function nextCopyId(createId) {
  if (typeof createId === 'function') return createId();
  return (typeof window !== 'undefined' && window.crypto?.randomUUID?.())
    || `copy-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function copyRolesAsVacant(roles, createId) {
  if (!Array.isArray(roles)) return [];
  return roles.map((role) => ({
    ...role,
    id: nextCopyId(createId),
    allowedTags: Array.isArray(role?.allowedTags) ? [...role.allowedTags] : [],
    slots: Array.isArray(role?.slots)
      ? role.slots.map((slot) => ({
          ...slot,
          id: nextCopyId(createId),
          assigneeUserId: null,
          assigneeDisplayName: '',
          responseStatus: null,
        }))
      : [],
  }));
}

/**
 * Turns an existing, normalised event form into safe initial data for a new
 * event. Configuration is retained, while identifiers and member-specific
 * state are deliberately discarded.
 */
export function buildEventCopyInitialData(source, createId) {
  const cleanSource = Object.fromEntries(
    Object.entries(source || {}).filter(([key]) => !key.startsWith('_'))
  );

  return {
    ...cleanSource,
    id: '',
    eventId: '',
    originalId: '',
    originalEventId: '',
    occurrenceId: '',
    // A copy is a new event, so make the admin deliberately choose when it
    // happens instead of silently reusing a potentially past source date.
    date: '',
    start: null,
    end: null,
    scope: '',
    isOccurrenceOverride: false,
    readOnly: false,
    publicSlug: '',
    publicEventsSlug: '',
    stripeProductId: '',
    stripePriceId: '',
    checkoutUrl: '',
    admissionTicketingLocked: false,
    externalConfigurationLocked: false,
    cancelled: false,
    cancelledAt: null,
    cancellation: null,
    createdAt: null,
    updatedAt: null,
    roles: copyRolesAsVacant(source?.roles, createId),
    ticketTypes: Array.isArray(source?.ticketTypes)
      ? source.ticketTypes.map((ticketType) => ({ ...ticketType }))
      : [],
    extras: Array.isArray(source?.extras)
      ? source.extras.map((extra) => ({ ...extra }))
      : [],
    bookingForm: source?.bookingForm ? { ...source.bookingForm } : null,
    _copySourceName: source?.name || 'event',
    _copyToken: nextCopyId(createId),
  };
}
